import { useQuery } from '@tanstack/react-query';
import { mtmRunsService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import type { MtmRunMarkRow } from '@/types';

/** GET /mtm-runs/{id}/marks/ — per-instrument rows for one run (lazy: enable on expand). */
export const useMtmRunMarks = (runId: number | null, enabled: boolean = true) => {
  return useQuery<MtmRunMarkRow[]>({
    queryKey: queryKeys.trades.mtmRunMarks(runId ?? 0),
    queryFn: () => mtmRunsService.getRunMarks(runId!),
    enabled: enabled && runId != null,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
